var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 19,
    viewBox: "0 0 14 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2227 4.34235C13.5391 4.65875 13.75 5.11578 13.75 5.53766V17.2095C13.75 18.1588 12.9766 18.897 12.0625 18.897H1.9375C0.988281 18.897 0.25 18.1588 0.25 17.2095V2.58453C0.25 1.67047 0.988281 0.897034 1.9375 0.897034H9.10938C9.53125 0.897034 9.98828 1.07281 10.3047 1.38922L13.2227 4.34235ZM11.9219 5.39703L9.25 2.72516V5.39703H11.9219ZM1.9375 17.2095H12.0625V7.08453H8.40625C7.91406 7.08453 7.5625 6.73297 7.5625 6.24078V2.58453H1.9375V17.2095Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileBold);
export default __webpack_public_path__ + "static/media/file-bold.b5a6c055b86b160772fe0fdd8b1f92cf.svg";
export { ForwardRef as ReactComponent };